export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Totala bilder genererade',
        cost: 'Kostnad',
        imagesPerDay: 'Bilder/dag',
    },
};
